module.exports = __webpack_public_path__ + "media/images/logo-large-ca3142f515f33c6a66579a0d49c3da72.png";